export default __webpack_public_path__ + "static/media/slowdeathstrike5.fd79a3ff.png";